import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import * as React from "react";
import * as MD from "@material-ui/core";
import { Dispatch } from "redux";
import { IApplicationState } from "../Store";
import { connect } from "react-redux";
import {
  adjustForTimezone,
  fromUTC,
  getDateHourZero,
  getDateOneDayBeforeTodayHourZero,
  getDateTodayHourZero,
} from "../Utils/Time";
import {
  IDashboardState,
  IDateType,
  monthsOfYear,
} from "../Store/Dashboard/Types";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { DateRange, LanguageType } from "react-date-range";

import { I18N, ILocaleInfos } from "../Store/I18n/Types";
import DatePicker from "react-datepicker";

import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { ILayoutState } from "../Store/Layout/Types";
import { enGB, fr } from "react-date-range/dist/locale";
import { PaletteMode } from "../Themes";
import { setDrawerContent } from "../Store/Layout/Actions";
import styled from "styled-components";
import { getDateCloture } from "../Store/Dashboard/Actions";
import {
  ISearchState,
  ITimeFilters,
  ITimeSlotHour,
  timeSlotsArr,
} from "../Store/Search/Types";
import { resetFilters, saveTimeFilters } from "../Store/Search/Actions";
import { IElectionsState } from "../Store/Elections/Types";
import "react-datepicker/dist/react-datepicker.css";
import { TypedStorage } from "../Utils/TypedStorage";
import {
  adjustEndDateForInclusion,
  getElectionDates,
  getMonthDates,
  getQuarterDates,
  getSemesterDates,
} from "../Utils/Date";

require("../calendar-dark.css");

const Styles = styled.div`
  .react-datepicker {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.8rem;
    background-color: #a66;
    border: 0px;
    border-radius: 0;
    display: inline-block;
    position: relative;
    color: black;
  }
`;
const styles = (theme: any) =>
  MD.createStyles({
    monthButton: {
      padding: "0px 9.5px",
      fontSize: "11px",
      minWidth: "100%",
      width: "100%",
      maxHeight: "15px",
      minHeight: "25px",
      borderRadius: "0px",
      border: "1px solid gray",
      borderTop: "0px",
      borderRight: "0px",
    },
    DateRange: {
      marginTop: "10px",
      border: "1px solid",
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      width: "90%",
      minWidth: "98%",
    },
    DateLabel: {
      fontFamily: "Lato",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: "0px",
      textAlign: "left",
      marginTop: "5px",
      paddingBottom: "10px",
    },
    timePicker: {
      width: "80px",
      margin: "3px",
      textAlign: "center",
      cursor: "pointer",
      padding: "5px 15px",
      border: 0,
      borderRadius: "4px",
      backgroundColor: theme.palette.background.paper,
      font: "inherit",
      color: theme.palette.text.primary,
    },
    buttonCalendar: {
      maxHeight: "15px",
      minHeight: "25px",
      fontSize: "11px",
      borderRadius: "0px",
      textTransform: "none",
      padding: "0px",
      width: "100%",
      minWidth: "100%",
    },
    buttonYear: {
      borderRadius: "0px",
      border: "1px solid gray",
      borderBottom: "0px",
      fontSize: 11,
    },
    inputClasses: {
      border: "1px gray",
    },
  });

interface IPropsFromDispatch {
  getDateCloture: typeof getDateCloture;
  saveTimeFilters: typeof saveTimeFilters;
  resetFilters: typeof resetFilters;
}

interface IOwnProps {
  saveDates: (
    startDate: Date,
    endDate: Date,
    startSlot: Date,
    endSlot: Date,
    dateType: IDateType,
    periodTitle?: string
  ) => void;
  getPlayerGroups?: (startDate: Date, endDate: Date) => void;
  hideGroupCalendar?: boolean;
  hideCalendar?: boolean;
  hideTime?: boolean;
  router?: any;
}
interface IAppState {
  //datePicker
  selectedYear: number;
  startDate: Date;
  endDate: Date;
  // timeSlot
  startSlot: Date;
  endSlot: Date;

  shownStartDate: Date;
  maxDateRange: Date;
  dateCloture: Date | null;
  election_update: boolean;
  maxDate: Date;

  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: any;
  dateType: IDateType;
  timeFiltersLoading: boolean;
  selectedHourTimeSlot: ITimeSlotHour | undefined;
}
type PeriodSelectionAllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromDispatch &
  IPropsFromState &
  IOwnProps;

const moment = extendMoment(originalMoment as any);

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  dashboard: IDashboardState;
  search: ISearchState;
  elections: IElectionsState;
}

const now = new Date();
const tomorrowMidnigth = new Date(now.getTime() + 24 * 60 * 60 * 1000);
tomorrowMidnigth.setHours(0, 0, 0, 0);

const initialState: any = {
  dateCloture: null,
  election_update: false,
  maxDate: tomorrowMidnigth,
  isSem1Activated: false,
  isSem2Activated: false,
  isFullYearSelected: false,
  isTrim1Selected: false,
  isTrim2Selected: false,
  isTrim3Selected: false,
  isTrim4Selected: false,
  selectedMonthIndex: null,
  dateType: "month",
  timeFiltersLoading: false,
  selectedHourTimeSlot: undefined,
};

export class PeriodSelectionComponent extends React.Component<
  PeriodSelectionAllProps,
  IAppState
> {
  public constructor(props: PeriodSelectionAllProps) {
    super(props);
    const zeroDay = new Date(0);
    zeroDay.setHours(0);
    this.state = {
      ...initialState,
      selectedYear: tomorrowMidnigth.getFullYear(),
      startDate: getDateHourZero(tomorrowMidnigth),
      startSlot: zeroDay,
      endSlot: zeroDay,
      shownStartDate: new Date(
        tomorrowMidnigth.getFullYear(),
        tomorrowMidnigth.getMonth(),
        1
      ),
      endDate: tomorrowMidnigth,
      maxDateRange: tomorrowMidnigth,
      selectedMonthIndex: tomorrowMidnigth.getUTCMonth(),
    };
  }

  public componentDidMount() {
    this.updateCalendarTheme();
    if (
      this.props.dashboard.dateCloture === null &&
      !this.props.dashboard.loadingDateCloture &&
      TypedStorage.get("userToken", "") !== ""
    ) {
      const token = TypedStorage.get("userToken", "");
      this.props.getDateCloture(token);
    }
  }

  public componentDidUpdate(prevProps: PeriodSelectionAllProps) {
    if (
      (this.props.elections.isElectionChecked !==
        prevProps.elections.isElectionChecked ||
        this.props.elections.study_type_id !==
        prevProps.elections.study_type_id) &&
      this.props.dashboard.dateCloture !== null &&
      this.props.elections.elections_start_date &&
      this.props.elections.elections_end_date
    ) {
      if (
        this.props.elections.isElectionChecked !==
        prevProps.elections.isElectionChecked
      ) {
        this.setState({ ...initialState });
      }

      const dateCloture = this.props.dashboard.dateCloture;
      let startDate = new Date(
        dateCloture.getUTCFullYear(),
        dateCloture.getUTCMonth(),
        1
      );
      let shownStartDate = startDate;

      if (this.props.elections.isElectionChecked) {
        const electionDates = getElectionDates(
          new Date(this.props.elections.elections_start_date),
          this.props.elections.elections_end_date,
          dateCloture
        );
        startDate = electionDates.startDate;
        this.setState({
          startDate: getDateHourZero(startDate),
          endDate: getDateHourZero(fromUTC(electionDates.endDate)),
          maxDate: electionDates.maxDate,
          maxDateRange: electionDates.maxDate,
          dateCloture,
          shownStartDate,
        });
      }
    }
  }

  static getDerivedStateFromProps(
    props: PeriodSelectionAllProps,
    state: IAppState
  ) {
    const pathParts = props.router?.location.pathname.split("/") || [];
    let nextState = { ...state };

    // Mise à jour des filtres de temps si on est sur /statistics ou /dashboard
    if (
      props.router !== undefined &&
      (pathParts[1] === "statistics" || pathParts[1] === "dashboard") &&
      props.search.timeFilters !== null &&
      !state.timeFiltersLoading &&
      !props.elections.isElectionChecked
    ) {
      nextState = {
        ...nextState,
        timeFiltersLoading: true,
        dateType: props.search.timeFilters.dateType,
        endDate: getDateHourZero(props.search.timeFilters.endDate),
        isFullYearSelected: props.search.timeFilters.isFullYearSelected,
        isSem1Activated: props.search.timeFilters.isSem1Activated,
        isSem2Activated: props.search.timeFilters.isSem2Activated,
        isTrim1Selected: props.search.timeFilters.isTrim1Selected,
        isTrim2Selected: props.search.timeFilters.isTrim2Selected,
        isTrim3Selected: props.search.timeFilters.isTrim3Selected,
        isTrim4Selected: props.search.timeFilters.isTrim4Selected,
        selectedMonthIndex: props.search.timeFilters.selectedMonthIndex,
        selectedYear: props.search.timeFilters.selectedYear,
        startDate: props.search.timeFilters.startDate,
      };
    }

    // Mise à jour des dates de clôture et des plages de dates
    if (
      props.dashboard.dateCloture !== null &&
      state.dateCloture === null &&
      !state.timeFiltersLoading &&
      props.elections.elections_start_date !== null &&
      props.elections.elections_end_date !== null
    ) {
      const dateCloture = getDateHourZero(props.dashboard.dateCloture);
      let startDate = new Date(
        dateCloture.getFullYear(),
        dateCloture.getUTCMonth(),
        1
      );
      // endDate représente la dernière date INCLUSIVE disponible
      let endDate = dateCloture;
      let shownStartDate = startDate;

      if (props.elections.isElectionChecked && !state.election_update) {
        const electionsStartDate = new Date(props.elections.elections_start_date);
        // Only apply election campaign dates if the election has already started.
        // Future elections (start > dateCloture) should keep the current-month default.
        if (electionsStartDate.getTime() <= dateCloture.getTime()) {
          const electionDates = getElectionDates(
            electionsStartDate,
            props.elections.elections_end_date,
            props.dashboard.dateCloture
          );
          startDate = electionDates.startDate;
          // electionDates.endDate est déjà normalisée côté utilitaire
          endDate = electionDates.endDate;
        }
        nextState = { ...nextState, election_update: true };
      }

      // normalizedEndDate = dernier jour inclus (à minuit)
      const normalizedEndDate = getDateHourZero(endDate);
      // rangeEndDate = borne exclusive (lendemain à minuit) utilisée pour les filtres
      const rangeEndDate = adjustEndDateForInclusion(normalizedEndDate);

      nextState = {
        ...nextState,
        startDate,
        endDate: rangeEndDate,
        maxDate: normalizedEndDate,
        dateCloture,
        selectedMonthIndex: normalizedEndDate.getUTCMonth(),
        selectedYear: normalizedEndDate.getFullYear(),
        maxDateRange: normalizedEndDate,
        shownStartDate,
      };
    }

    return nextState;
  }

  private updateCalendarTheme() {
    const { theme } = this.props;

    let elems: any = document.getElementsByClassName("rdrDayDisabled");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.fontWeight = 500;
      }
    }
    elems = document.getElementsByClassName("rdrDateDisplayWrapper");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.backgroundColor = theme.palette.background.default;
        elems[i].style.fontWeight = 500;
      }
    }
    elems = document.getElementsByClassName("rdrDateDisplayItem");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        if (elems[i].getElementsByTagName("input").length > 0) {
          elems[i].getElementsByTagName("input")[0].style.color =
            theme.palette.text.primary;
        }
        elems[i].style.backgroundColor = theme.palette.background.paper;
        elems[i].style.border = "0px";
        elems[i].style.fontWeight = 500;
      }
    }
    elems = document.getElementsByClassName("rdrDateDisplay");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.backgroundColor = theme.palette.background.default;
        elems[i].style.fontWeight = 500;
      }
    }
    elems = document.getElementsByClassName("rdrMonthAndYearPickers");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.color = theme.palette.text.primary;
        elems[i].style.fontWeight = 500;
        elems[i].style.fontSize = "14px";
      }
    }

    elems = document.getElementsByClassName("rdrWeekDay");
    if (elems !== null) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.fontSize = "14px";
        elems[i].style.color = theme.palette.text.primary;
      }
    }
  }

  private updateSem1() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getSemesterDates(
        this.state.selectedYear,
        true,
        dateCloture
      );
      // Si le semestre est tronqué par la date de clôture (semestre en cours),
      // on inclut aussi le lendemain du dernier jour sélectionné.
      const semestreEnd = new Date(this.state.selectedYear, 6, 1);
      const isPartialSemester = endDate < semestreEnd;
      const rangeEndDate = isPartialSemester
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: maxDate,
        isSem1Activated: true,
        isSem2Activated: false,
        isFullYearSelected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        selectedMonthIndex: -1,
        dateType: "semester",
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "semester",
        `Premier semestre ${this.state.selectedYear}`
      );
      this.props.saveTimeFilters({
        startDate,
        endDate: truncatedRangeEndDate,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        isSem1Activated: true,
        isSem2Activated: false,
        isFullYearSelected: false,
        isTrim1Selected: false,
        isTrim2Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        selectedMonthIndex: -1,
        dateType: "semester",
        selectedYear: this.state.selectedYear,
      });
    }
  }
  private updateSem2() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getSemesterDates(
        this.state.selectedYear,
        false,
        dateCloture
      );
      const semestreEnd = new Date(this.state.selectedYear, 12, 1);
      const isPartialSemester = endDate < semestreEnd;
      const rangeEndDate = isPartialSemester
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: maxDate,
        isSem1Activated: false,
        isSem2Activated: true,
        isFullYearSelected: false,
        isTrim1Selected: false,
        isTrim2Selected: false,
        selectedMonthIndex: -1,
        dateType: "semester",
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "semester",
        `Deuxième semestre ${this.state.selectedYear}`
      );
      this.props.saveTimeFilters({
        startDate,
        endDate: truncatedRangeEndDate,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        isSem1Activated: false,
        isSem2Activated: true,
        isFullYearSelected: false,
        isTrim1Selected: false,
        isTrim2Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        selectedMonthIndex: -1,
        dateType: "semester",
        selectedYear: this.state.selectedYear,
      });
    }
  }
  private moveNext = () => {
    let endDate = getDateOneDayBeforeTodayHourZero(getDateTodayHourZero());
    if (this.state.dateCloture !== null) {
      endDate = getDateHourZero(this.state.dateCloture);
    }
    let twoDaysBeforeToday = endDate;
    let newEndDate = this.state.isFullYearSelected
      ? new Date(this.state.startDate.getFullYear() + 1, 12, 1)
      : this.state.isSem1Activated
        ? new Date(this.state.startDate.getFullYear() + 1, 6, 1)
        : this.state.isSem2Activated
          ? new Date(this.state.startDate.getFullYear() + 1, 12, 1)
          : this.state.isTrim1Selected
            ? new Date(this.state.startDate.getFullYear() + 1, 3, 1)
            : this.state.isTrim2Selected
              ? new Date(this.state.startDate.getFullYear() + 1, 6, 1)
              : this.state.isTrim3Selected
                ? new Date(this.state.startDate.getFullYear() + 1, 9, 1)
                : this.state.isTrim4Selected
                  ? new Date(this.state.startDate.getFullYear() + 1, 12, 1)
                  : this.state.dateType === "month"
                    ? new Date(
                      this.state.startDate.getFullYear() + 1,
                      this.state.startDate.getMonth() + 1,
                      1
                    )
                    : new Date(
                      this.state.startDate.getFullYear() + 1,
                      this.state.endDate.getMonth(),
                      this.state.endDate.getDate()
                    );
    newEndDate =
      twoDaysBeforeToday < newEndDate ? twoDaysBeforeToday : newEndDate;
    let newState = { ...this.state };
    let monthIndex = newState.selectedMonthIndex;
    let startDate = new Date(
      this.state.selectedYear + 1,
      this.state.startDate.getMonth(),
      this.state.startDate.getDate()
    );
    if (startDate > twoDaysBeforeToday) {
      newEndDate = twoDaysBeforeToday;
    }
    if (
      startDate > new Date(newEndDate.getFullYear(), newEndDate.getMonth(), 1)
    ) {
      startDate = new Date(newEndDate.getFullYear(), newEndDate.getMonth(), 1);
      monthIndex = newEndDate.getMonth();
    }
    let dateType = this.state.dateType;
    if (
      new Date(
        this.state.startDate.getFullYear() + 1,
        this.state.startDate.getMonth(),
        this.state.startDate.getDate()
      ) > endDate
    ) {
      this.setState({ dateType: "calendar" });
      dateType = "calendar";
    }
    this.props.saveDates(
      startDate,
      endDate,
      this.state.startSlot,
      this.state.endSlot,
      dateType,
      undefined
    );
    let selectedYear = this.state.selectedYear;
    this.setState({
      selectedYear: selectedYear + 1,
      startDate: startDate,
      shownStartDate: startDate,
      endDate: getDateHourZero(newEndDate),
      maxDateRange: newEndDate,
      selectedMonthIndex: monthIndex,
    });
    this.props.saveTimeFilters({
      selectedYear: selectedYear + 1,
      startDate: startDate,
      endDate: getDateHourZero(newEndDate),
      startSlot: this.state.startSlot,
      endSlot: this.state.endSlot,
      selectedMonthIndex: monthIndex,
      isSem1Activated: this.state.isSem1Activated,
      isSem2Activated: this.state.isSem2Activated,
      isFullYearSelected: this.state.isFullYearSelected,
      isTrim1Selected: this.state.isTrim1Selected,
      isTrim2Selected: this.state.isTrim2Selected,
      isTrim3Selected: this.state.isTrim3Selected,
      isTrim4Selected: this.state.isTrim4Selected,
      dateType: dateType,
    });
  };
  private movePrev = () => {
    let endDate = getDateHourZero(
      this.state.isFullYearSelected
        ? new Date(this.state.startDate.getFullYear() - 1, 12, 1)
        : this.state.isSem1Activated
          ? new Date(this.state.startDate.getFullYear() - 1, 6, 1)
          : this.state.isSem2Activated
            ? new Date(this.state.startDate.getFullYear() - 1, 12, 1)
            : this.state.isTrim1Selected
              ? new Date(this.state.startDate.getFullYear() - 1, 3, 1)
              : this.state.isTrim2Selected
                ? new Date(this.state.startDate.getFullYear() - 1, 6, 1)
                : this.state.isTrim3Selected
                  ? new Date(this.state.startDate.getFullYear() - 1, 9, 1)
                  : this.state.isTrim4Selected
                    ? new Date(this.state.startDate.getFullYear() - 1, 12, 1)
                    : this.state.dateType === "month"
                      ? new Date(
                        this.state.startDate.getFullYear() - 1,
                        this.state.startDate.getMonth() + 1,
                        1
                      )
                      : new Date(
                        this.state.startDate.getFullYear() - 1,
                        this.state.endDate.getMonth(),
                        this.state.endDate.getDate()
                      )
    );
    let selectedYear = this.state.selectedYear;
    this.props.saveTimeFilters({
      selectedYear: selectedYear - 1,
      startDate: new Date(
        this.state.selectedYear - 1,
        this.state.startDate.getMonth(),
        this.state.startDate.getDate()
      ),
      endDate: getDateHourZero(endDate),
      startSlot: this.state.startSlot,
      endSlot: this.state.endSlot,
      isSem1Activated: this.state.isSem1Activated,
      isSem2Activated: this.state.isSem2Activated,
      isFullYearSelected: this.state.isFullYearSelected,
      isTrim1Selected: this.state.isTrim1Selected,
      isTrim2Selected: this.state.isTrim2Selected,
      isTrim3Selected: this.state.isTrim3Selected,
      isTrim4Selected: this.state.isTrim4Selected,
      selectedMonthIndex: this.state.selectedMonthIndex,
      dateType: this.state.dateType,
    });
    this.setState({
      selectedYear: selectedYear - 1,
      startDate: new Date(
        this.state.selectedYear - 1,
        this.state.startDate.getMonth(),
        this.state.startDate.getDate()
      ),
      shownStartDate: new Date(
        this.state.selectedYear - 1,
        this.state.startDate.getMonth(),
        this.state.startDate.getDate()
      ),
      endDate: getDateHourZero(endDate),
      maxDateRange: getDateHourZero(endDate),
    });
    this.props.saveDates(
      new Date(this.state.selectedYear - 1, this.state.startDate.getMonth(), 1),
      endDate,
      this.state.startSlot,
      this.state.endSlot,
      this.state.dateType,
      undefined
    );
  };

  private handleYearChange = () => {
    let endDate = this.props.dashboard.dateCloture;
    if (endDate !== null) {
      const yearEnd = new Date(this.state.selectedYear, 12, 1);
      const rawEndDate =
        endDate < yearEnd ? adjustForTimezone(endDate) : yearEnd;

      // Si l'année est en cours (tronquée par la date de clôture),
      // on inclut aussi le lendemain du dernier jour sélectionné.
      const isPartialYear = rawEndDate < yearEnd;
      const rangeEndDate = isPartialYear
        ? adjustEndDateForInclusion(getDateHourZero(rawEndDate))
        : rawEndDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      const maxDate = endDate < yearEnd ? endDate : yearEnd;
      this.setState({
        isFullYearSelected: true,
        startDate: new Date(this.state.selectedYear, 0, 1),
        shownStartDate: new Date(this.state.selectedYear, 0, 1),
        endDate: truncatedRangeEndDate,
        dateType: "annual",

        maxDateRange: maxDate,
      });
      this.props.saveTimeFilters({
        isFullYearSelected: true,
        startDate: new Date(this.state.selectedYear, 0, 1),
        endDate: truncatedRangeEndDate,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        dateType: "annual",
        selectedYear: this.state.selectedYear,
        isSem1Activated: this.state.isSem1Activated,
        isSem2Activated: this.state.isSem2Activated,
        isTrim1Selected: this.state.isTrim1Selected,
        isTrim2Selected: this.state.isTrim2Selected,
        isTrim3Selected: this.state.isTrim3Selected,
        isTrim4Selected: this.state.isTrim4Selected,
        selectedMonthIndex: this.state.selectedMonthIndex,
      });
      this.props.saveDates(
        new Date(this.state.selectedYear, 0, 1),
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "annual",
        `Année ${this.state.selectedYear}`
      );
    }
  };

  private updateTrim1() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getQuarterDates(
        this.state.selectedYear,
        1,
        dateCloture
      );
      const quarterEnd = new Date(this.state.selectedYear, 3, 1);
      const isPartialQuarter = endDate < quarterEnd;
      const rangeEndDate = isPartialQuarter
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        isTrim1Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim2Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: maxDate,
        dateType: "quarter",
      });
      this.props.saveTimeFilters({
        isTrim1Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim2Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startDate,
        endDate: truncatedRangeEndDate,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        dateType: "quarter",
        selectedYear: this.state.selectedYear,
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "quarter",
        `Premier trimestre ${this.state.selectedYear}`
      );
    }
  }
  private updateTrim2() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getQuarterDates(
        this.state.selectedYear,
        2,
        dateCloture
      );
      const quarterEnd = new Date(this.state.selectedYear, 6, 1);
      const isPartialQuarter = endDate < quarterEnd;
      const rangeEndDate = isPartialQuarter
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        isTrim2Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: getDateHourZero(maxDate),
        dateType: "quarter",
      });
      this.props.saveTimeFilters({
        isTrim2Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim3Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        selectedMonthIndex: -1,
        startDate,
        endDate: truncatedRangeEndDate,
        dateType: "quarter",
        selectedYear: this.state.selectedYear,
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "quarter",
        `Deuxième trimestre ${this.state.selectedYear}`
      );
    }
  }
  private updateTrim3() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getQuarterDates(
        this.state.selectedYear,
        3,
        dateCloture
      );
      const quarterEnd = new Date(this.state.selectedYear, 9, 1);
      const isPartialQuarter = endDate < quarterEnd;
      const rangeEndDate = isPartialQuarter
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        isTrim3Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim2Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: maxDate,
        dateType: "quarter",
      });
      this.props.saveTimeFilters({
        isTrim3Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim2Selected: false,
        isTrim4Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        startDate,
        endDate: truncatedRangeEndDate,
        dateType: "quarter",
        selectedYear: this.state.selectedYear,
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "quarter",
        `Troisième trimestre ${this.state.selectedYear}`
      );
    }
  }
  private updateTrim4() {
    const dateCloture = this.props.dashboard.dateCloture;
    if (dateCloture !== null) {
      const { startDate, endDate, maxDate } = getQuarterDates(
        this.state.selectedYear,
        4,
        dateCloture
      );
      const quarterEnd = new Date(this.state.selectedYear, 12, 1);
      const isPartialQuarter = endDate < quarterEnd;
      const rangeEndDate = isPartialQuarter
        ? adjustEndDateForInclusion(getDateHourZero(endDate))
        : endDate;
      const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

      this.setState({
        isTrim4Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim3Selected: false,
        isTrim2Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        startDate,
        shownStartDate: startDate,
        endDate: truncatedRangeEndDate,
        maxDateRange: getDateHourZero(maxDate),
        dateType: "quarter",
      });
      this.props.saveTimeFilters({
        isTrim4Selected: true,
        isSem1Activated: false,
        isSem2Activated: false,
        isTrim1Selected: false,
        isTrim3Selected: false,
        isTrim2Selected: false,
        isFullYearSelected: false,
        selectedMonthIndex: -1,
        startDate,
        startSlot: this.state.startSlot,
        endSlot: this.state.endSlot,
        endDate: truncatedRangeEndDate,
        dateType: "quarter",
        selectedYear: this.state.selectedYear,
      });
      this.props.saveDates(
        startDate,
        rangeEndDate,
        this.state.startSlot,
        this.state.endSlot,
        "quarter",
        `Quatrième trimestre ${this.state.selectedYear}`
      );
    }
  }

  private handleSelectedMonth(index: number) {
    const dateLimit =
      this.state.dateCloture !== null
        ? this.state.dateCloture
        : getDateOneDayBeforeTodayHourZero(getDateTodayHourZero());

    const {
      startDate,
      endDate: tmpEndDate,
      maxDate,
    } = getMonthDates(this.state.selectedYear, index, dateLimit);

    const normalizedEndDate = getDateHourZero(tmpEndDate);
    const isPartialMonth = normalizedEndDate.getMonth() === startDate.getMonth();
    const rangeEndDate = isPartialMonth
      ? adjustEndDateForInclusion(normalizedEndDate)
      : normalizedEndDate;

    const truncatedRangeEndDate = getDateHourZero(rangeEndDate);

    this.setState({
      selectedMonthIndex: index,
      isFullYearSelected: false,
      isSem1Activated: false,
      isSem2Activated: false,
      isTrim1Selected: false,
      isTrim2Selected: false,
      isTrim3Selected: false,
      isTrim4Selected: false,
      startDate,
      shownStartDate: startDate,
      endDate: truncatedRangeEndDate,
      maxDateRange: maxDate,
      dateType: "month",
    });
    this.props.saveTimeFilters({
      selectedMonthIndex: index,
      isFullYearSelected: false,
      isSem1Activated: false,
      isSem2Activated: false,
      isTrim1Selected: false,
      isTrim2Selected: false,
      isTrim3Selected: false,
      isTrim4Selected: false,
      startSlot: this.state.startSlot,
      endSlot: this.state.endSlot,
      startDate,
      endDate: truncatedRangeEndDate,
      dateType: "month",
      selectedYear: this.state.selectedYear,
    });
    this.props.saveDates(
      startDate,
      rangeEndDate,
      this.state.startSlot,
      this.state.endSlot,
      "month",
      `${monthsOfYear[index]} ${this.state.selectedYear}`
    );
  }

  private handleSelect(ranges: any) {
    let d: Date = getDateHourZero(new Date(ranges["selection"]["endDate"]));
    let newDate: Date = new Date(new Date(d).setDate(d.getDate() + 1));
    this.setState({
      startDate: ranges["selection"]["startDate"],
      shownStartDate: ranges["selection"]["startDate"],
      endDate: getDateHourZero(newDate),
      maxDateRange: new Date(new Date(newDate).setDate(newDate.getDate() - 1)),
      dateType: "calendar",
      isFullYearSelected: false,
      isSem1Activated: false,
      isSem2Activated: false,
      isTrim1Selected: false,
      isTrim2Selected: false,
      isTrim3Selected: false,
      isTrim4Selected: false,
    });
    this.props.saveTimeFilters({
      startDate: ranges["selection"]["startDate"],
      endDate: getDateHourZero(newDate),
      dateType: "calendar",
      isFullYearSelected: false,
      isSem1Activated: false,
      isSem2Activated: false,
      isTrim1Selected: false,
      isTrim2Selected: false,
      isTrim3Selected: false,
      isTrim4Selected: false,
      selectedMonthIndex: this.state.selectedMonthIndex,
      startSlot: this.state.startSlot,
      endSlot: this.state.endSlot,
      selectedYear: this.state.selectedYear,
    });
    this.props.saveDates(
      ranges["selection"]["startDate"],
      newDate,
      this.state.startSlot,
      this.state.endSlot,
      "calendar",
      `${ranges["selection"]["startDate"].toLocaleString(
        this.props.localeInfos.momentLocale
      )} au ${newDate.toLocaleString(this.props.localeInfos.momentLocale)}`
    );
    if (this.props.getPlayerGroups) {
      this.props.getPlayerGroups(ranges["selection"]["startDate"], newDate);
    }
  }
  private handleStartTimeChange(date: Date) {
    this.setState({ startSlot: date });
    this.props.saveDates(
      this.state.startDate,
      this.state.endDate,
      date,
      this.state.endSlot,
      this.state.dateType,
      undefined
    );
    if (this.props.getPlayerGroups) {
      this.props.getPlayerGroups(date, this.state.endDate);
    }
  }
  private handleEndTimeChange(date: Date) {
    const newDate = adjustEndDateForInclusion(date);
    this.setState({ endSlot: newDate });
    this.props.saveDates(
      this.state.startDate,
      this.state.endDate,
      this.state.startSlot,
      date,
      this.state.dateType,
      undefined
    );
    if (this.props.getPlayerGroups) {
      this.props.getPlayerGroups(this.state.startDate, newDate);
    }
  }
  private isDisabled = (index: number) => {
    let endDate = getDateOneDayBeforeTodayHourZero(getDateTodayHourZero());
    if (this.state.dateCloture !== null) {
      endDate = this.state.dateCloture;
    }
    return (
      index > endDate.getUTCMonth() &&
      this.state.selectedYear === endDate.getFullYear()
    );
  };

  private drawCalendar() {
    const { classes, theme } = this.props;
    let endDate = tomorrowMidnigth;
    if (this.state.dateCloture !== null) {
      endDate = this.state.dateCloture;
    }
    return (
      <div id="calendar" style={{ flexGrow: 1 }}>
        <MD.Grid container spacing={0}>
          <MD.Grid item xs={12} style={{ textAlign: "center" }}>
            <MD.IconButton
              onClick={this.movePrev.bind(this)}
              disabled={this.state.selectedYear === 2018}
              aria-label="first page"
            >
              <NavigateBeforeIcon />
            </MD.IconButton>
            <MD.Button
              className={classes.buttonYear}
              id="year"
              style={{
                backgroundColor: this.state.isFullYearSelected
                  ? "darkmagenta"
                  : undefined,
                color: this.state.isFullYearSelected
                  ? theme.palette.primary.light
                  : undefined,
                padding: "2px 15px",
              }}
              variant="outlined"
              onClick={this.handleYearChange.bind(this)}
            >
              {this.state.selectedYear}
            </MD.Button>
            <MD.IconButton
              onClick={this.moveNext.bind(this)}
              disabled={this.state.selectedYear === endDate.getFullYear()}
              aria-label="first page"
            >
              <NavigateNextIcon />
            </MD.IconButton>
          </MD.Grid>
          <MD.Grid item xs={6}>
            <MD.Button
              className={classes.buttonCalendar}
              id="sem1"
              disabled={this.isDisabled(0)}
              style={{
                borderBottom: 0,
                borderRight: 0,
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(0) &&
                    (this.state.isSem1Activated || this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(0) &&
                    (this.state.isSem1Activated || this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateSem1()}
            >
              1e Sem.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={6}>
            <MD.Button
              className={classes.buttonCalendar}
              id="sem2"
              disabled={this.isDisabled(6)}
              style={{
                borderBottom: 0,
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(6) &&
                    (this.state.isSem2Activated || this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(6) &&
                    (this.state.isSem2Activated || this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateSem2()}
            >
              2e Sem.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={3}>
            <MD.Button
              className={classes.buttonCalendar}
              id="trim1"
              disabled={this.isDisabled(0)}
              style={{
                borderRight: 0,
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(0) &&
                    (this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(0) &&
                    (this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateTrim1()}
            >
              1e Trim.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={3}>
            <MD.Button
              className={classes.buttonCalendar}
              id="trim2"
              disabled={this.isDisabled(3)}
              style={{
                borderRight: 0,
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(3) &&
                    (this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(3) &&
                    (this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateTrim2()}
            >
              2e Trim.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={3}>
            <MD.Button
              className={classes.buttonCalendar}
              id="trim3"
              disabled={this.isDisabled(6)}
              style={{
                borderRight: 0,
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(6) &&
                    (this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(6) &&
                    (this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateTrim3()}
            >
              3e Trim.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={3}>
            <MD.Button
              className={classes.buttonCalendar}
              id="trim4"
              disabled={this.isDisabled(9)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(9) &&
                    (this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(9) &&
                    (this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.updateTrim4()}
            >
              4e Trim.
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(0)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(0) &&
                    (this.state.selectedMonthIndex === 0 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(0) &&
                    (this.state.selectedMonthIndex === 0 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(0)}
            >
              J
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(1)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(1) &&
                    (this.state.selectedMonthIndex === 1 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(1) &&
                    (this.state.selectedMonthIndex === 1 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(1)}
            >
              F
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(2)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(2) &&
                    (this.state.selectedMonthIndex === 2 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(2) &&
                    (this.state.selectedMonthIndex === 2 ||
                      this.state.isTrim1Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(2)}
            >
              M
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(3)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(3) &&
                    (this.state.selectedMonthIndex === 3 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(3) &&
                    (this.state.selectedMonthIndex === 3 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(3)}
            >
              A
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(4)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(4) &&
                    (this.state.selectedMonthIndex === 4 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(4) &&
                    (this.state.selectedMonthIndex === 4 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(4)}
            >
              M
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(5)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(5) &&
                    (this.state.selectedMonthIndex === 5 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(5) &&
                    (this.state.selectedMonthIndex === 5 ||
                      this.state.isTrim2Selected ||
                      this.state.isSem1Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(5)}
            >
              J
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(6)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(6) &&
                    (this.state.selectedMonthIndex === 6 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(6) &&
                    (this.state.selectedMonthIndex === 6 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(6)}
            >
              J
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(7)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(7) &&
                    (this.state.selectedMonthIndex === 7 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(7) &&
                    (this.state.selectedMonthIndex === 7 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(7)}
            >
              A
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(8)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(8) &&
                    (this.state.selectedMonthIndex === 8 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(8) &&
                    (this.state.selectedMonthIndex === 8 ||
                      this.state.isTrim3Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(8)}
            >
              S
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(9)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(9) &&
                    (this.state.selectedMonthIndex === 9 ||
                      this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  !this.isDisabled(9) &&
                    (this.state.selectedMonthIndex === 9 ||
                      this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(9)}
            >
              O
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(10)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(10) &&
                    (this.state.selectedMonthIndex === 10 ||
                      this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                color:
                  (this.state.selectedMonthIndex === 10 ||
                    this.state.isTrim4Selected ||
                    this.state.isSem2Activated ||
                    this.state.isFullYearSelected) &&
                    !this.isDisabled(10)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(10)}
            >
              N
            </MD.Button>
          </MD.Grid>
          <MD.Grid item xs={1}>
            <MD.Button
              className={classes.monthButton}
              disabled={this.isDisabled(11)}
              style={{
                backgroundColor:
                  this.state.dateType !== "calendar" &&
                    !this.isDisabled(11) &&
                    (this.state.selectedMonthIndex === 11 ||
                      this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? "green"
                    : undefined,
                borderRight: "1px solid gray",
                color:
                  !this.isDisabled(11) &&
                    (this.state.selectedMonthIndex === 11 ||
                      this.state.isTrim4Selected ||
                      this.state.isSem2Activated ||
                      this.state.isFullYearSelected)
                    ? theme.palette.primary.light
                    : undefined,
              }}
              variant="outlined"
              onClick={() => this.handleSelectedMonth(11)}
            >
              D
            </MD.Button>
          </MD.Grid>
        </MD.Grid>
      </div>
    );
  }
  public onReset() {
    let endDate = tomorrowMidnigth;
    if (this.props.dashboard.dateCloture !== null) {
      endDate = this.props.dashboard.dateCloture;
    }
    this.setState({
      ...initialState,
      selectedYear: endDate.getFullYear(),
      startDate: new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1),
      shownStartDate: new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1),
      endDate: endDate,
    });
    this.props.resetFilters();
  }
  private drawDateRange() {
    const { classes, localeInfos, theme } = this.props;
    let format: string = "",
      locale: Locale = fr;
    if (localeInfos.momentLocale === "en-us") {
      format = "MM/dd/yyyy";
      locale = enGB;
    } else if (localeInfos.momentLocale === "fr") {
      format = "dd/MM/yyyy";
      locale = fr;
    }
    let endDate = tomorrowMidnigth;
    let maxDate = this.state.maxDate;
    let startDate = this.state.startDate;
    if (this.state.dateCloture !== null) {
      endDate = this.state.dateCloture;
      if (startDate > endDate) {
        startDate = endDate;
      }
    }

    let minDate =
      this.props.elections.isElectionChecked &&
      this.props.elections.elections_start_date !== null
        ? adjustForTimezone(new Date(this.props.elections.elections_start_date))
        : new Date(endDate.getFullYear() - 2, 0, 1);

    if (minDate > maxDate) {
      minDate = new Date(endDate.getFullYear() - 2, 0, 1);
    }

    let lang: LanguageType = localeInfos.momentLocale as any;
    const selectionRange = () => {
      return {
        startDate: startDate,
        endDate: this.state.maxDateRange,
        key: "selection",
        color:
          this.props.layout.theme === PaletteMode.DARK
            ? theme.palette.secondary.main
            : "#b2b0f1",
        showDateDisplay: true,
      };
    };

    return (
      <div id="date-range">
        <DateRange
          className={classes.DateRange}
          ranges={[selectionRange()]}
          onChange={this.handleSelect.bind(this)}
          startDate={moment(startDate)}
          endDate={moment(adjustForTimezone(this.state.endDate))}
          minDate={minDate as any}
          maxDate={maxDate as any}
          showMonthAndYearPickers={false}
          locale={locale}
          format={format}
          lang={lang}
          moveRangeOnFirstSelection={true}
        />
      </div>
    );
  }
  private drawTimeSlot() {
    const { i18n, classes } = this.props;
    return (
      <div id="time-slot" style={{ display: "inline-flex" }}>
        <MD.Typography className={classes.DateLabel}>
          {i18n._("Time slot")}
        </MD.Typography>
        <div id="timePicker" style={{ display: "inline-flex" }}>
          <Styles>
            <DatePicker
              timeFormat="HH:mm"
              selected={this.state.startSlot}
              onChange={this.handleStartTimeChange.bind(this)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="HH:mm"
              className={this.props.classes.timePicker}
            />
          </Styles>
          <Styles>
            <DatePicker
              timeFormat="HH:mm"
              selected={this.state.endSlot}
              onChange={this.handleEndTimeChange.bind(this)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="HH:mm"
              className={this.props.classes.timePicker}
            />
          </Styles>
        </div>
      </div>
    );
  }
  private handleTimeSlotHourChange(ev: any) {
    let value = ev.currentTarget.value;
    let selectedHourTimeSlot: ITimeSlotHour = timeSlotsArr.filter(
      (x) => x.value === value
    )[0];
    this.setState({
      selectedHourTimeSlot,
    });
    let defaultStartDate = adjustForTimezone(new Date(this.state.startDate))
      .toISOString()
      .substring(0, 10);
    defaultStartDate = defaultStartDate + " " + selectedHourTimeSlot.startTime;
    let startDate = new Date(defaultStartDate);
    let defaultEndDate = new Date(this.state.endDate)
      .toISOString()
      .substring(0, 10);
    defaultEndDate = defaultEndDate + " " + selectedHourTimeSlot.endTime;
    let endDate = new Date(defaultEndDate);

    this.setState({ endDate, startDate });
    this.props.saveDates(
      startDate,
      endDate,
      this.state.startSlot,
      this.state.endSlot,
      this.state.dateType,
      undefined
    );
  }
  private drawTimeHoursSlot() {
    return (
      <div id="time-hour-slot">
        <MD.NativeSelect
          id="demo-customized-select-native"
          value={this.state.selectedHourTimeSlot?.value}
          onChange={this.handleTimeSlotHourChange.bind(this)}
          input={
            <MD.OutlinedInput className={this.props.classes.inputClasses} />
          }
        >
          {timeSlotsArr.map((x: ITimeSlotHour) => {
            return (
              <option key={x.identifiant} value={x.value}>
                {x.value}
              </option>
            );
          })}
        </MD.NativeSelect>
      </div>
    );
  }
  public render(): React.ReactNode {
    this.updateCalendarTheme();

    return (
      <MD.Grid
        container
        justifyContent="space-around"
        style={{ marginTop: 10 }}
      >
        {!this.props.hideGroupCalendar &&
          !this.props.elections.isElectionChecked &&
          this.drawCalendar()}
        {this.props.dashboard.dateCloture === null && (
          <MD.CircularProgress color="primary" />
        )}
        {!this.props.hideCalendar &&
          this.props.dashboard.dateCloture !== null &&
          this.drawDateRange()}
        {!this.props.hideTime && this.drawTimeSlot()}
        {!this.props.hideTime &&
          this.props.elections.isElectionChecked &&
          this.drawTimeHoursSlot()}
      </MD.Grid>
    );
  }
}

const mapStateToProps = ({
  layout,
  i18n,
  ui,
  dashboard,
  search,
  elections,
}: IApplicationState) => ({
  layout,
  localeInfos: i18n.localeInfos,
  i18n: i18n.i18n,
  ui,
  dashboard,
  search,
  elections,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
  getDateCloture: (token: string) => dispatch(getDateCloture(token)),
  saveTimeFilters: (filters: ITimeFilters) =>
    dispatch(saveTimeFilters(filters)),
  resetFilters: () => dispatch(resetFilters()),
});

const PeriodSelection = connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(MD.withTheme(MD.withStyles(styles)(PeriodSelectionComponent)));

export { PeriodSelection };
